// "Demo opnieuw beginnen" (nacht 05-11, S7): maakt het demoplan leeg zodat een
// volgende demo schoon begint. Eén klik doet wat Beheer anders in twee stappen deed:
// de keuzes van testaccounts wissen en het plan terugzetten naar "niet gestart".
// De server weigert alles wat geen demo is, dus het echte E&O-plan blijft ongemoeid.

import { useState } from "react";

import { ApiError, api } from "../../lib/api";
import { Foutmelding, Knop } from "../../stijl";

export function DemoOpnieuw({
  propositie,
  jaar,
  naam,
  klaar,
}: {
  propositie: string;
  jaar: number;
  naam: string;
  klaar: () => void;
}) {
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState<{ fout: boolean; tekst: string } | null>(null);
  const begin = async () => {
    const vraag =
      `${naam} opnieuw beginnen?\n\n` +
      "Alle keuzes van de demo-accounts in dit plan gaan weg en het plan staat daarna weer op “niet gestart”. " +
      "Het echte plan van Economie & Ondernemen verandert niet.";
    if (!window.confirm(vraag)) return;
    setBezig(true);
    setMelding(null);
    try {
      const r = await api.demoOpnieuw(propositie, jaar);
      setMelding({
        fout: false,
        tekst: r.gewist === 1 ? "Opnieuw begonnen: 1 keuze gewist." : `Opnieuw begonnen: ${r.gewist} keuzes gewist.`,
      });
      klaar();
    } catch (e) {
      setMelding({ fout: true, tekst: e instanceof ApiError ? e.message || e.reason : "Opnieuw beginnen is niet gelukt." });
    } finally {
      setBezig(false);
    }
  };
  return (
    <span className="pp-wis">
      <Knop variant="zacht" disabled={bezig} onClick={() => void begin()} aria-label={`Demo opnieuw beginnen: ${naam}`}>
        {bezig ? "Bezig…" : "Demo opnieuw beginnen"}
      </Knop>
      {melding &&
        (melding.fout ? <Foutmelding>{melding.tekst}</Foutmelding> : <span className="s-veldblok__uitleg">{melding.tekst}</span>)}
    </span>
  );
}
